<template>
    <div class="container section">
        <div class="row heading">
            <div class="col">
                <h2>Products</h2>
            </div>
            <div class="col text-right" v-show="admin">
                <button class="btn btn-primary" @click="showAddProduct = true">Add Product</button>
            </div>
        </div>

        <div class="row table-head">
            <div class="col-1 checkbox">Enabled</div>
            <div class="col">Carrier Name</div>
            <div class="col">Telephone Number</div>
            <div class="col">IP Address</div>
            <div class="col"v-show="admin"></div>
        </div>

        <div class="row" v-for="v, i in products" :key="v.product_id">

            <div class="col-1 checkbox">
                <input :disabled="!$canAccess(21,22)" type="checkbox" class="form-control" v-model="v.enabled" @change="save(v)">
            </div>
            <div class="col">{{v.name}}</div>
            <div class="col">{{v.ip | showCheck}}</div>
            <div class="col">{{v.telno | showCheck}}</div>
            <div class="col text-right" v-show="admin">
                <button class="btn btn-sm btn-primary" @click.stop="setSelected(v);" >
                    <i class="fa fa-pencil"></i>
                </button>
                <dropdown-confirmation @confirm="deleteProduct(v)"></dropdown-confirmation>
            </div>
        </div>


        <modal v-if="showAddProduct" allow-click-away="false">
            <div slot="header">
                <h3 class="modal-title d-inline d-flex justify-content-start">Add Product</h3>
                <button type="button" class="btn btn-clear close-btn" @click="resetSelected(); showAddProduct = false" >
                    <i class="fa fa-remove"  />
                </button>
            </div>
            </h3>

            <div slot="body">
                <div class="row">
                    <div class="col-4">Product Name</div>
                    <div class="col-8 col-sm-6">
                        <input type="text" class="form-control" v-model="selected.name" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">Telephone</div>
                    <div class="col-8 col-sm-6">
                        <input type="text" class="form-control" v-model="selected.telephone" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">IP Address</div>
                    <div class="col-8 col-sm-6">
                        <input type="text" class="form-control" v-model="selected.ip_address" />
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-clear" @click.stop="resetSelected(); showAddProduct = false">Cancel</button>
                    <button class="btn btn-primary" @click.stop="create()"><i class="fa fa-check"></i>Save Product</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script type="text/babel">
    import Modal from '../assets/Modal.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    export default {
        name: 'CarrierProducts',
        data: function () {
            return {
                selected: {
                    product_id: '',
                    name:'',
                    telephone: '',
                    ip_address:''
                },
                showAddProduct: false,
                products: []
            }
        },
        props: ['carrier_id', 'admin'],
        components: {
            DropdownConfirmation,
            Modal
        },
        created(){
            this.fetchData();
        },
        filters: {
            showCheck(val){
                return true;
            }
        },
        methods:{

            fetchData(){

                this.$send(this, 'products', {
                    carrier_id: this.carrier_id
                }).then(r => {
                    this.products = r.products;
                });


            },
            setSelected(v){
                this.selected.product_id = v.product_id;
                this.selected.name = v.name;
                this.selected.telephone = v.telephone;
                this.selected.ip_address = v.ip_address;

                this.showAddProduct = true;

            },
            resetSelected(){
                this.selected = {
                    product_id: '',
                    name:'',
                    telephone: '',
                    ip_address:''
                };
            },
            save(p){
                p.carrier_id = this.carrier_id;
                this.$send(this, 'carrierProductUpdate', p);
            },
            create(p){

                var fn = (this.selected.product_id)? 'productEdit':'productCreate';

                this.$send(this, fn, this.selected).then(r => {
                    this.fetchData();
                    this.resetSelected();
                    this.showAddProduct = false;
                })

            },
            deleteProduct(p){
                console.log(p)
                this.$send(this, 'productDelete', p).then(r => {
                    this.fetchData();
                })
            }
        }
    }


</script>


// WEBPACK FOOTER //
// CarrierProducts.vue?b49adca0